module.exports = __webpack_public_path__ + "static/media/install.0bd76958.svg";